export default __webpack_public_path__ + "static/ionic-banner-fe4dfaf571fc62986373453079e2dedc.webp";